(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mata-product__grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mata-product-grid-recommendations')) {
    class MataProductGridRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.querySelector('.product-grid__item')) {
          this.initializeProductCardCarousels();
          return;
        }

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;

              const recommendationsWrapper = html.querySelector('mata-product-grid-recommendations');
              const recommendationsContent = recommendationsWrapper?.innerHTML.trim()
                || html.querySelector('.product-grid__items-wrapper')?.outerHTML;

              if (recommendationsContent) {
                this.innerHTML = recommendationsContent;
                this.initializeProductCardCarousels();
              }
            })
            .catch(error => {
              console.error(error);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }

      initializeProductCardCarousels() {
        if (typeof $ === 'undefined' || typeof $.fn.flickity === 'undefined') return;

        $(this).find('.product-card__media-carousel:not(.flickity-enabled)').each((_index, carousel) => {
          const $carousel = $(carousel);
          const $productCard = $carousel.closest('.product-card');
          const $colors = $productCard.find('.product-card__colors li span');

          $colors.off('click.productCardCarousel').on('click.productCardCarousel', (event) => {
            $colors.removeClass('is-active');
            $(event.currentTarget).addClass('is-active');
            $carousel.flickity('selectCell', $(event.currentTarget).data('index'));
          });

          $carousel.flickity({
            selectedAttraction: 0.1,
            friction: 0.55,
            wrapAround: true,
            contain: true,
            prevNextButtons: false,
            pageDots: true
          });
        });
      }
    }

    customElements.define('mata-product-grid-recommendations', MataProductGridRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
